import type { EditorScreen } from '@/store/editorSlice';

/**
 * WEB-1330 п.2 (вариант А): страница с авторским блоком cookie_consent
 * (конструктор → палитра → CookieConsentBlock, PublicBlockRendererExtended.tsx)
 * ведёт согласие сама. Системный ConsentBanner (frontend/src/components/consent/
 * ConsentBanner.tsx, показывается со страницы PublicQuiz.tsx/PublicPaywall.tsx)
 * не должен подниматься одновременно с ним — два баннера согласия на одной
 * странице недопустимы (карточка требует разрешить конфликт в пользу
 * авторского блока).
 */
export function hasCookieConsentBlock(
  screens: readonly EditorScreen[] | undefined,
): boolean {
  if (!screens) return false;
  return screens.some((screen) =>
    screen.blocks.some((block) => block.type === 'cookie_consent'),
  );
}
